var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',_vm._l((_vm.catalogs),function(catalog){return _c('v-col',{key:catalog.id},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.show(catalog.id)}}},[_vm._v(_vm._s(catalog.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }